import { API_BASE_URL } from "../config/apiConfig"

export const b2cRegister = async (userData) => {
  const response = await fetch(`${API_BASE_URL}/b2c/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  })

  return response.json()
}

export const b2cLogin = async (email, password, companyName) => {
  const response = await fetch(`${API_BASE_URL}/b2c/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password, companyName }),
  })

  return response.json()
}

export const b2cVerifyOTP = async (email, otp) => {
  const response = await fetch(`${API_BASE_URL}/b2c/verify-otp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, otp }),
  })

  return response.json()
}

export const b2cResendOTP = async (email) => {
  const response = await fetch(`${API_BASE_URL}/b2c/resend-otp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  })

  return response.json()
}

export const b2cForgotPassword = async (email) => {
  const response = await fetch(`${API_BASE_URL}/b2c/forgot-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  })

  return response.json()
}

export const b2cResetPassword = async (email, otp, newPassword) => {
  const response = await fetch(`${API_BASE_URL}/b2c/reset-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, otp, newPassword }),
  })

  return response.json()
}

export const b2cGetProfile = async (token) => {
  const response = await fetch(`${API_BASE_URL}/b2c/profile`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  return response.json()
}

export const b2cUpdateProfile = async (token, formData) => {
  const response = await fetch(`${API_BASE_URL}/b2c/profile`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData, // FormData will automatically set the correct Content-Type with boundary
  })

  return response.json()
}
